export const SHOW_PROFILE = 'SHOW_PROFILE';
export const CLOSE_PROFILE = 'CLOSE_PROFILE';
